/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o índice, a
 * camada do mapa e o clique num ponto com chuva.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { registerCoordinatePopup } from '../map/popupControl';
import { mapToLonLat } from '../map/projection';
import { GsmapLayerManager, PALETA_GSMAP } from './camada';
import { GsmapPopup } from './GsmapPopup';
import { useGsmapStore } from './store';
import { iniciarSyncGsmap, registrarNovaTentativa } from './sync';

export { refreshGsmap } from './sync';

export function useGsmapLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncGsmap(), []);

  useEffect(() => {
    if (!map) return;
    const manager = new GsmapLayerManager(map);
    registrarNovaTentativa(() => manager.tentarDeNovo());
    // Registrado depois do radar: onde houver eco, a ficha do radar (medida de perto) responde primeiro.
    const tirarPopup = registerCoordinatePopup(([x, y]) => {
      if (!useGsmapStore.getState().visivel) return null;
      const [lon, lat] = mapToLonLat(x, y);
      if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
      const r = manager.valorNaTela(lon, lat);
      // Sem chuva no ponto (abaixo da escala) ou sem dado: o clique segue para o município.
      if (!r || !(r.v >= PALETA_GSMAP.paradas[0].v)) return null;
      return createElement(GsmapPopup, { v: r.v, q: r.q, lonLat: [lon, lat] });
    });
    return () => {
      tirarPopup();
      registrarNovaTentativa(null);
      manager.dispose();
    };
  }, [map]);
}
